export default __webpack_public_path__ + "static/media/logo-bicca-v2.ae1728de.png";